import React from "react";
import ButtonBasic from "./ButtonBasic";
import { Spinner } from "react-bootstrap";

export default function ButtonSpinner({ id, cypressid, label, ...props }) {
  return (
    <ButtonBasic id={id} cypressid={cypressid} {...props}>
      {label}...{" "}
      <Spinner animation='border' role='status' variant='light' size='sm' style={{ marginLeft: "0.7rem" }}>
        <span className='sr-only'></span>
      </Spinner>
    </ButtonBasic>
  );
}

ButtonSpinner.defaultProps = {
  theme: "deq-primary",
  label: "Processing",
  cypressid: "processing"
};
